<script>
  import { getNotificationsContext } from "svelte-notifications";
  import { useQuery, useQueryClient } from "@sveltestack/svelte-query"
  import Section from "../../../components/layout/Section.svelte";
  import SectionTitle from "../../../components/layout/SectionTitle.svelte";
  import SectionSeparator from "../../../components/layout/SectionSeparator.svelte";
  import Stack from "../../../components/layout/Stack.svelte";
  import { getAutoMpsProjectContext } from "../../AutoMpsProjectContext.js";
  import HelpTooltip from "../../../components/tooltip/HelpTooltip.svelte";
  import ToggleSwitch from "../../../components/input/ToggleSwitch.svelte";

  const ctx = getAutoMpsProjectContext()
  const {addNotification} = getNotificationsContext()

  const queryClient = useQueryClient()
  const query = useQuery(`/api/auto-mps/projects/${$ctx.projectId}/settings/asprova`)

  async function onClickEnableDebug() {
    const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/debug/enable`, {method: "POST"})
    if (response.ok) {
      addNotification({
        text: "デバッグモードを有効にしました。",
        type: "success",
        removeAfter: 4000,
        position: "top-right",
      })
      await queryClient.invalidateQueries(`/api/auto-mps/projects/${$ctx.projectId}/settings/asprova`)
    } else {
      addNotification({
        text: "有効化に失敗しました。",
        type: "error",
        removeAfter: 4000,
        position: "top-right",
      })
    }
  }

  async function onClickDisableDebug() {
    const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/debug/disable`, {method: "POST"})
    if (response.ok) {
      addNotification({
        text: "デバッグモードを無効にしました。",
        type: "success",
        removeAfter: 4000,
        position: "top-right",
      })
      await queryClient.invalidateQueries(`/api/auto-mps/projects/${$ctx.projectId}/settings/asprova`)
    } else {
      addNotification({
        text: "無効化に失敗しました。",
        type: "error",
        removeAfter: 4000,
        position: "top-right",
      })
    }
  }

  let isSubmitting = false
  async function toggleDebugMode(toggledValue) {
    isSubmitting = true
    if (toggledValue) {
      await onClickEnableDebug()
    } else {
      await onClickDisableDebug()
    }
    isSubmitting = false
  }
</script>

<Section>
  <SectionTitle>デバッグ設定</SectionTitle>
  <SectionSeparator />
  <Stack direction="vertical">
    <Stack direction="horizontal" alignItems="center">
      <span>
        デバッグモード
        <HelpTooltip title="デバッグモード">
          デバッグモードが有効なとき、リスケジュールが終わったあと、AsprovaのUIを表示して停止します。
          手動でAsprovaが終了されるまでは実行が完了しないため、後続の実行はブロックされる点に注意してください。
        </HelpTooltip>
      </span>
      :
      <ToggleSwitch
        disabled={isSubmitting}
        on={$query.data?.debug}
        onChange={e => toggleDebugMode(e.target.checked)}
      />
    </Stack>
  </Stack>
</Section>
